import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Send } from "lucide-react";
import { api, ApiError } from "../lib/api";
import { useVendors } from "../lib/useReference";
import { useToast } from "../lib/toast";
import { Card } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { FieldInput, FieldSelect } from "../components/ui/Field";
import { RESIN_TYPES } from "@gsp/shared";

/** CRPPC — Recycled Content / Packaging Declaration. Code-verified field
 * set (Resin Type / Sub-Commodity / % Post-Consumer Material), NOT conflict
 * minerals — see ADLC 01_Source_Baseline.md Source Conflict Register #8. */
export function Crppc() {
  const { data: vendors } = useVendors();
  const [form, setForm] = useState({ vendorId: "", materialNumber: "", resinType: RESIN_TYPES[0] as string, subCommodity: "", postConsumerPct: "" });
  const toast = useToast();

  const submitMutation = useMutation({
    mutationFn: () => api.post("/crppc/declarations", { ...form, vendorId: Number(form.vendorId), postConsumerPct: Number(form.postConsumerPct) }),
    onSuccess: () => toast("CRPPC declaration submitted"),
    onError: (err) => toast(err instanceof ApiError ? err.message : "Submission failed", "error"),
  });

  return (
    <Card className="max-w-xl p-6">
      <h2 className="font-semibold text-lg mb-4">CRPPC — Recycled Content / Packaging Declaration</h2>
      <div className="grid grid-cols-2 gap-4">
        <FieldSelect label="Vendor" value={form.vendorId} onChange={(e) => setForm((f) => ({ ...f, vendorId: e.target.value }))} options={[{ value: "", label: "Select vendor…" }, ...(vendors ?? []).map((v) => ({ value: v.id, label: v.name }))]} />
        <FieldInput label="Material Number" value={form.materialNumber} onChange={(e) => setForm((f) => ({ ...f, materialNumber: e.target.value }))} />
        <FieldSelect label="Resin Type" value={form.resinType} onChange={(e) => setForm((f) => ({ ...f, resinType: e.target.value }))} options={RESIN_TYPES.map((r) => ({ value: r, label: r }))} />
        <FieldInput label="Sub-Commodity" value={form.subCommodity} onChange={(e) => setForm((f) => ({ ...f, subCommodity: e.target.value }))} />
        <FieldInput label="% Post-Consumer Material" type="number" value={form.postConsumerPct} onChange={(e) => setForm((f) => ({ ...f, postConsumerPct: e.target.value }))} />
      </div>
      <div className="flex justify-end mt-6">
        <Button icon={Send} onClick={() => submitMutation.mutate()} disabled={submitMutation.isPending}>
          Submit
        </Button>
      </div>
    </Card>
  );
}
